import { useContext, useEffect, useRef, useState } from 'react'
import utility from 'src/utils/utility'
import ApiContext from 'src/provider/API/call-service'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { Button, CustomContainer, FlexRow, PageTitle, PageWrapper } from 'src/style'
import { Filter, ServerSideTable } from 'src/component'
import { auditData, auditColumns } from 'src/utils/table-layout'
import helpers from 'src/utils/helpers'

const Audit = () => {
    const {API, downloadReport} = useContext(ApiContext)
    const {setInfoProperty} = useContext(AppInfoContext)
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<any>(null)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [view, setView] = useState<string>('')
    
    const filterDataRef = useRef({})

    useEffect(() => {
        filterDataRef.current = {}
        handleFetchReport()
    }, [])

    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const response = {data: auditData, total: 4}

        if (response) {
            if (isDownload) {
                return downloadReport(response, 'AUDIT_REPORT')
            }

            response.data = helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize})

            setReportData(response)
            setReport(response.data)
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    return (
        <>
            <PageWrapper>
                <CustomContainer topMargin='2.5'>
                    <FlexRow 
                        justifyContent='space-between' alignItems='flex-start' 
                        bottomMargin='1.5' gap='1.5' wrap='wrap'
                    >
                        <PageTitle 
                            color='#101828' textSize='3' fontWeight="500"
                        >
                            Audit
                        </PageTitle>
                    </FlexRow>
                    <ServerSideTable
                        tableData={report}
                        tableColumns={auditColumns} 
                        dataFetchMethod={handleFetchReport}
                        totalRows={reportData?.total}
                        customStyle
                        shouldResetPagination={resetPagination}
                        canFilter={() => setView('filter')}
                        canClear={handleClear}
                        downloadAction={() => handleFetchReport(1, 10, true)}
                    />
                </CustomContainer>
            </PageWrapper>
            { view === 'filter' &&
                <Filter
                    type='audit'
                    onApplyFilter={handleFetchReport}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setView('')}
                    top='32'
                />
            }
        </>
    )
}

export default utility.routeData('audit', 'Audit', <Audit/>)